<template>
<div>
    <test-page-header
        :title="trans.list_title"
    />

    <div class="columns is-multiline m-0 fixed-with-overflow-y small-scrollbar">
        <div
            class="column is-6-desktop is-12-tablet"
            :class="cardSizeClasses"
            v-if="isUserCanCreateTest"
        >
            <test-list-new-test-card />
        </div>
        <div
            class="column is-6-desktop is-12-tablet"
            :class="cardSizeClasses"
            v-for="test in tests"
        >
            <test-list-card
                :test="test"
            />
        </div>
    </div>
</div>
</template>

<script>
import TestListCard from "./TestListCard";
import {mapActions, mapGetters} from "vuex";
import TestListNewTestCard from "./TestListNewTestCard";
export default {
    name: "TestList",
    components: {TestListNewTestCard, TestListCard},
    computed: {
        ...mapGetters('tests', [
            'tests',
            'isUserCanCreateTest',
            'trans',
            'isFullScreenTest',
        ]),
        cardSizeClasses() {
            return {
                'is-4-fullhd': !this.isFullScreenTest,
                'is-3-fullhd': this.isFullScreenTest,
            };
        }
    },
    mounted() {
        this.loadTestsList();
    },
    methods: {
        ...mapActions('tests', [
            'loadTestsList',
            'hideTestsManagementPage',
        ]),
    }
}
</script>
